<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'
import { filtersRichtext, textLenHandler } from '@/utils/common'

export default {
  name: 'Comp49',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor, filtersRichtext, textLenHandler,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-49">
    <module-title :title="moduleOption.title" margin-bottom="30" />
    <div class="comp-transverse-2 modules-id-49-content">
      <div
        v-for="(v, i) in moduleOption.list.slice(0, 4)"
        :key="`modules-id-49-item-${i}`"
        class="item"
        @click="onModuleItem(v)"
      >
        <div class="item-left">
          <p class="item-headline h-line-2">{{ v.headline }}</p>
          <div class="line-box">
            <el-image class="line" :src="require('imgs/modules/comp49-line.png')" alt="cover" />
          </div>
          <p class="item-memo h-line-2">{{ filtersRichtext(v.memo) }}</p>
        </div>
        <div class="img-box">
          <el-image class="item-img" :src="v.photo | imgPath" alt="cover" fit="cover" />
          <el-image v-if="i === 0" class="line-rb" :src="require('imgs/modules/comp48-rb.png')" alt="line" />
          <el-image v-if="i === 1" class="line-rt" :src="require('imgs/modules/comp48-rt.png')" alt="line" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-49-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .item {
    display: flex;
    justify-content: space-between;
    width: 688px;
    box-sizing: border-box;
    .item-left {
      width: 344px;
      height: 155px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .item-headline {
      width: 270px;
      font-size: 17px;
      font-weight: 800;
      color: #000;
      margin-top: 40px;
    }
    .line-box {
      width: 270px;
      .line {
        width: 103px;
        height: 9px;
        transform: translateY(-9px);
      }
    }
    .item-memo {
      width: 270px;
      font-size: 14px;
      font-weight: 500;
      color: #000;
      line-height: 18px;
      margin-top: 20px;
    }
  }
  .item:nth-child(even) {
    display: flex;
    flex-direction: row-reverse;
  }
  .img-box {
    position: relative;
    .item-img {
      width: 344px;
      height: 155px;
      border-radius: 5px;
    }
    .line-rb, .line-rt {
      width: 25px;
      height: 24px;
    }
    .line-rb {
      position: absolute;
      right: -9px;
      bottom: -5px;
    }
    .line-rt {
      position: absolute;
      right: -8px;
      top: -7px;
    }
  }
}
</style>
